"use client";

import { Modals } from "@/components";
import React from "react";
import "moment/locale/id";

const MainLayout = ({ children }: { children: React.ReactNode }) => {
  return (
    <>
      {children}
      <Modals />
    </>
  );
};

export default MainLayout;
